import { GET_FREE_CREDIT_SUCCESS } from '../actions/userTypeActions'
export default (state = false, { type, data = false }) => {
  switch (type) {
    case GET_FREE_CREDIT_SUCCESS:
      return data
    default:
      return state
  }
}
